import { Search, ShoppingCart, CreditCard, PackageCheck, Smartphone, Home } from 'lucide-react'
import { VILLES } from '../data/magasins'
import './HowItWorks.css'

const steps = [
  {
    step: '01',
    icon: Search,
    title: { fr: 'Parcourez le catalogue', en: 'Browse the catalog' },
    desc: { fr: 'Parcourez les rayons, filtrez par prix et repérez les promotions en cours.', en: 'Browse the departments, filter by price and spot current deals.' },
    color: '#003DA5',
  },
  {
    step: '02',
    icon: ShoppingCart,
    title: { fr: 'Ajoutez au panier', en: 'Add to cart' },
    desc: { fr: 'Choisissez vos articles, sélectionnez les options (couleur, taille) et ajoutez-les à votre panier en un clic.', en: 'Choose your items, select options (color, size) and add them to your cart in one click.' },
    color: '#E30613',
  },
  {
    step: '03',
    icon: CreditCard,
    title: { fr: 'Payez comme vous voulez', en: 'Pay your way' },
    desc: { fr: 'Choisissez votre mode de paiement : Orange Money, ou directement à la réception de votre commande.', en: 'Choose your preferred payment: Orange Money, or cash when your order arrives.' },
    color: '#FF6600',
    paymentOptions: true,
  },
  {
    step: '04',
    icon: PackageCheck,
    title: { fr: 'Recevez à domicile', en: 'Receive at home' },
    desc: {
      fr: `Notre équipe livre votre commande directement chez vous à ${VILLES.join(', ')}.`,
      en: `Our team delivers your order directly to you in ${VILLES.join(', ')}.`,
    },
    color: '#065F46',
  },
]

const paymentPills = {
  fr: [
    { Icon: Smartphone, label: 'Orange Money', sub: 'Paiement en ligne' },
    { Icon: Home,       label: 'À la livraison', sub: 'Paiement cash' },
  ],
  en: [
    { Icon: Smartphone, label: 'Orange Money', sub: 'Online payment' },
    { Icon: Home,       label: 'On delivery', sub: 'Cash payment' },
  ],
}

export default function HowItWorks({ lang }) {
  const t = (obj) => obj[lang]

  return (
    <section className="how-it-works" id="comment-commander">
      <div className="hiw-inner">
        <div className="hiw-header reveal">
          <h2 className="section-title">
            {lang === 'fr' ? 'Commander en' : 'Order in'} <span>4 {lang === 'fr' ? 'étapes simples' : 'simple steps'}</span>
          </h2>
          <p className="section-subtitle">
            {lang === 'fr'
              ? 'De la sélection à la livraison, ABBUSINESS rend votre expérience d\'achat aussi simple et agréable que possible.'
              : 'From selection to delivery, ABBUSINESS makes your shopping experience as simple and enjoyable as possible.'}
          </p>
        </div>

        <div className="hiw-steps">
          {steps.map((step, i) => {
            const Icon = step.icon
            return (
              <div
                key={i}
                className={`hiw-step reveal delay-${i + 1}`}
                style={{ '--step-color': step.color }}
              >
                <div className="step-connector" aria-hidden="true" />

                <div className="step-icon-wrap">
                  <div className="step-number">{step.step}</div>
                  <div className="step-icon">
                    <Icon size={28} />
                  </div>
                </div>

                <div className="step-content">
                  <h3 className="step-title">{t(step.title)}</h3>
                  <p className="step-desc">{t(step.desc)}</p>

                  {step.paymentOptions && (
                    <div className="step-payment-options">
                      {paymentPills[lang].map(({ Icon: PIcon, label, sub }, j) => (
                        <div key={j} className={`payment-pill ${j === 0 ? 'pill-orange' : 'pill-delivery'}`}>
                          <div className="payment-pill-icon">
                            <PIcon size={14} />
                          </div>
                          <div className="payment-pill-text">
                            <span className="payment-pill-label">{label}</span>
                            <span className="payment-pill-sub">{sub}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>

        {/* CTA block */}
        <div className="hiw-cta reveal">
          <div className="hiw-cta-inner">
            <div className="hiw-cta-text">
              <h3>{lang === 'fr' ? 'Prêt à commander ?' : 'Ready to order?'}</h3>
              <p>
                {lang === 'fr'
                  ? `Paiement à la réception ou par Orange Money, livraison à ${VILLES.join(', ')}.`
                  : `Pay on delivery or with Orange Money, delivered in ${VILLES.join(', ')}.`}
              </p>
            </div>
            <a href="#categories" className="btn btn-primary">
              {lang === 'fr' ? 'Commencer mes achats' : 'Start shopping'}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
